import { render } from "./ChurchDashboard.vue?vue&type=template&id=51f0a93a&scoped=true"
import script from "./ChurchDashboard.vue?vue&type=script&lang=js"
export * from "./ChurchDashboard.vue?vue&type=script&lang=js"

import "./ChurchDashboard.vue?vue&type=style&index=0&id=51f0a93a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f0a93a"]])

export default __exports__